import { apiRequestActions } from '@ackee/redux-utils';
import { fetchUsersRolesAndPermissionsTypes } from './types';

export default apiRequestActions(fetchUsersRolesAndPermissionsTypes);
